import styled from 'styled-components';

export const Main = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, .5);
`;

export const Container = styled.div`
	position: fixed;
	top: 50%;
	left: 50%;
	width: 100%;
	max-width: 420px;
	border-radius: 4px;
	background: #fff;
	transform: translate(-50%, -50%);
`;

export const Inner = styled.div`
	display: flex;
	flex-flow: column;
	align-items: center;
	justify-content: center;
	padding: 60px 40px;
	p,
	ul li {
		margin: 1em 0;
		font-size: 1.05rem;
		text-align: center;
		+ button {
			margin-top: 1.5em;
		}
		&:last-child {
			margin-bottom: 0;
		}
	}
	ul li {
		line-height: 1.4;
	}
	a {
		color: #1d1d1d;
		text-decoration: underline;
		&:hover,
		&:visited {
			color: #1d1d1d;
			text-decoration: underline;
		}
	}
	form {
		width: 100%;
		max-width: 280px;
		margin: 0 auto;
	}
	input[type=text] {
		width: 100%;
		max-width: none;
		border: 0 !important;
		border-bottom: 2px solid #1d1d1d !important;
		border-radius: 0 !important;
		margin-bottom: 1.5em;
		padding: 0;
		font-size: 1rem;
		text-align: left;
		&:focus {
			box-shadow: none;
			outline: unset;
		}
	}
	button.rgModalButton,
	input[type=submit] {
		cursor: pointer;
		width: 80%;
		margin-bottom: 0.75em;
		padding: 7px 30px;
		border: 2px solid #1d1d1d;
		border-radius: 4px;
		line-height: 1.45;
		font-weight: 500;
		font-size: 1.05rem;
		background-color: #fff;
		&.primary {
			background-color: #1d1d1d;
			color: #fff;
		}
		&[disabled] {
			opacity: 0.5;
		}
	}
	input[type=submit] {
		width: 100%;
		margin-top: 1em;
	}
`;

export const CloseButton = styled.button`
	position: absolute;
	top: 15px;
	right: 15px;
	cursor: pointer;
	border: 0;
	background: transparent;
	color: rgba(0, 0, 0, .5);
`;

export const Title = styled.h4`
	margin: 0 0 0.5em;
	line-height: 1.25;
	font-size: 1.7rem;
	color: #1d1d1d;
	text-align: center;
`;

export const TadaPoints = styled.ul`
	li:before {
		content: '🎉 ';
	}
`;
